import { ActionTypes } from "store/constants";
import { filter } from "lodash";
import { cloneDeep } from "lodash";

const sentenceStarterInit = [];
const popUpHandler = {
  open: false,
  type: "",
  data: [],
  confirmationDialog: false
};

/**
 * Sentence Starter Popup Reducer
 *
 * Handles the state of the sentence starter popup modal.
 *
 * @param {Object} state - The current state of the sentence starter popup modal.
 * @param {Object} action - The action object that triggered this reducer.
 * @property {boolean} action.payload.open - A boolean indicating whether the popup
 *   should be open or closed.
 * @property {string} action.payload.type - The type of popup to open. Currently
 *   only "edit" is supported.
 * @property {array} action.payload.data - An array of sentence starter objects to
 *   display in the popup.
 * @returns {Object} The new state of the sentence starter popup modal.
 */
export const sentenceStarterPopup = (state = popUpHandler, action) => {
  switch (action.type) {
    case ActionTypes.sentenceStarterPopup.updateOpenPopup:
      return { ...state, ...action.payload };

    case ActionTypes.sentenceStarterPopup.setOpenPopup:
      return action.payload;
    default:
      return state;
  }
};

/**
 * Sentence Starter Reducer
 *
 * Manages the state of sentence starters, handling actions related to listing,
 * updating, deleting, and creating sentence starters.
 *
 * @param {Array} state - The current state of the sentence starters, initialized
 *   with an empty array.
 * @param {Object} action - The action object that triggers this reducer.
 * @property {string} action.type - The type of action to be handled.
 * @property {Object} action.payload - The payload containing data for the action.
 * @returns {Array} The updated state of the sentence starters.
 */

export const sentenceStarter = (state = sentenceStarterInit, action) => {
  switch (action.type) {
    case ActionTypes.sentenceStarter.listSenteceStarter:
      return action.payload;
    case ActionTypes.sentenceStarter.updateSenteceStarter:
      return state.map((x) => {
        if (x.id === action.payload?.id) {
          return { ...x, ...action.payload };
        }
        return x;
      });
    case ActionTypes.sentenceStarter.deleteSenteceStarter:
      const delv = cloneDeep(state);
      const result = filter(delv, (k) => k.id != action.payload.id);
      return result;
    case ActionTypes.sentenceStarter.createSenteceStarter:
      return action.payload?.data;
    default:
      return state;
  }
};
